/**
 * @generated SignedSource<<045ae4cc165971e624aae7a6f3695d44>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubSpotAnalyticsEvent = "CREATED_FIRST_ORGANIZATION_APP" | "CREATED_FIRST_PERSONAL_APP" | "CREATED_ORGANIZATION" | "CREATED_ORGANIZATION_APP" | "CREATED_PERSONAL_APP" | "SYNCED_USER_COLLECTION" | "%future added value";
export type HubSpotAnalyticsEventMetadata = {
  appDataEvent?: never;
  appEvent: AppProperties;
  organizationEvent?: never;
} | {
  appDataEvent: AppDataProperties;
  appEvent?: never;
  organizationEvent?: never;
} | {
  appDataEvent?: never;
  appEvent?: never;
  organizationEvent: OrganizationProperties;
};
export type AppProperties = {
  appId: string;
  appName?: string | null | undefined;
  appSlug?: string | null | undefined;
  organizationId?: string | null | undefined;
  organizationSlug?: string | null | undefined;
  userId?: string | null | undefined;
};
export type AppDataProperties = {
  appId: string;
  collection?: string | null | undefined;
  userId?: string | null | undefined;
};
export type OrganizationProperties = {
  organizationId: string;
  organizationSlug?: string | null | undefined;
};
export type useAnalyticsHoseMutation$variables = {
  event: HubSpotAnalyticsEvent;
  meta?: HubSpotAnalyticsEventMetadata | null | undefined;
};
export type useAnalyticsHoseMutation$data = {
  readonly pushAnalyticsEvent: {
    readonly ok: boolean;
  };
};
export type useAnalyticsHoseMutation = {
  response: useAnalyticsHoseMutation$data;
  variables: useAnalyticsHoseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "event"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meta"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "meta"
      }
    ],
    "concreteType": "Response",
    "kind": "LinkedField",
    "name": "pushAnalyticsEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAnalyticsHoseMutation",
    "selections": (v1/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAnalyticsHoseMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1049d5643879640e9c9fb7856bb1c42e",
    "id": null,
    "metadata": {},
    "name": "useAnalyticsHoseMutation",
    "operationKind": "mutation",
    "text": "mutation useAnalyticsHoseMutation(\n  $event: HubSpotAnalyticsEvent!\n  $meta: HubSpotAnalyticsEventMetadata\n) {\n  pushAnalyticsEvent(event: $event, metadata: $meta) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "52a6d924c87af57ad42111f26b175ecf";

export default node;
